import * as ProtoHall from "./proto_hall";
import NetMsgDataToBuffer from "../../../../framework/net/net_msgdata_to_buffer";


export class NetMsgDataMapHall extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:1为登录服，2为麻将游戏服，3为Skynet扑克服
    static Account_Login: any[] = [1, ProtoHall.Auth.CMD_Login, 1, ProtoHall.Auth.RSP_Login, 1]
    static Creat_Room: any[] = [2, ProtoHall.Auth.CMD_CreateRoom, 2, ProtoHall.Auth.RSP_CreateRoom, 1]
    static Join_Room: any[] = [3, ProtoHall.Auth.CMD_EnterRoom, 3, ProtoHall.Auth.RSP_EnterRoom, 1]

    static Enter_Hall: any[] = [4, ProtoHall.Auth.CMD_EnterHall, 4, ProtoHall.Auth.RSP_EnterHall, 1]
    static Ping: any[] = [5, ProtoHall.Auth.CMD_Ping, 5, ProtoHall.Auth.RSP_Ping, 1]
    static Gold_Enter: any[] = [6, ProtoHall.Auth.CMD_GoldEnter, 6, ProtoHall.Auth.RSP_GoldEnter, 1]
    static Gold_Quit: any[] = [7, ProtoHall.Auth.CMD_GoldQuit, 7, ProtoHall.Auth.RSP_GoldQuit, 1]
    static Notify_GoldRoomInfo: any[] = [8, ProtoHall.Auth.Notify_GoldRoomInfo, 8, ProtoHall.Auth.Notify_GoldRoomInfo, 1]
    static Match_SignUp: any[] = [9, ProtoHall.Auth.CMD_MatchSignUp, 9, ProtoHall.Auth.RSP_MatchSignUp, 1]
    static Match_Witchdraw: any[] = [10, ProtoHall.Auth.CMD_MatchWithdraw, 10, ProtoHall.Auth.RSP_MatchWithdraw, 1]
    static Notify_MatchEvent: any[] = [11, ProtoHall.Auth.Notify_MatchEvent, 11, ProtoHall.Auth.Notify_MatchEvent, 1]
    static Notify_MatchRoomInfo: any[] = [12, ProtoHall.Auth.Notify_MatchRoomInfo, 12, ProtoHall.Auth.Notify_MatchRoomInfo, 1]
    static Match_Enter: any[] = [13, ProtoHall.Auth.CMD_MatchEnter, 13, ProtoHall.Auth.RSP_MatchEnter, 1]
    static Notify_Extrusion: any[] = [14, ProtoHall.Auth.Notify_Extrusion, 14, ProtoHall.Auth.Notify_Extrusion, 1]
    static Match_Quit: any[] = [15, ProtoHall.Auth.CMD_MatchQuit, 15, ProtoHall.Auth.CMD_MatchQuit, 1]
    static Match_Ready: any[] = [16, ProtoHall.Auth.CMD_MatchReady, 16, ProtoHall.Auth.RSP_MatchReady, 1]
}
